import { Category as CoreCategory, ICategoryData } from '@df/catalog/category/category';
import { CategoryResource } from '@df/catalog/category/category.resource';
import { TLoadDependeciesParams } from '@df/catalog/model';
import { NgInject } from '@df/ng/ng-inject';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { ICmsConfigResource } from '@icms/core/resource/config/icms-config.resource';
import { NAttributeOrder } from '../../../cms/config/attribute-order.cms-config';
import { VipService } from '../../../module/vip/vip.service';

export class LocalCategory<T extends ICategoryData = ICategoryData> extends CoreCategory<T> {
    @NgInject(ICmsBlockResource)
    private iCmsBlockResource!: ICmsBlockResource;

    @NgInject(ICmsConfigResource)
    private iCmsConfigResource!: ICmsConfigResource;

    @NgInject(VipService)
    private vipService!: VipService;

    get cmsBlockHeaderVariant(): string {
        return 'category-header' + this.id;
    }
    protected override addDependenciesToLoader(params: TLoadDependeciesParams): void {
        super.addDependenciesToLoader(params);
        if (this.verbosity! > 2) {
            if (this.lpLayoutVariant) {
                params.loader.add(
                    this.iCmsBlockResource.retrieve({ bareUrl: 'category-page-layout', variant: this.lpLayoutVariant, createOnError: true }, params)
                );
            }

            if (this.iCmsConfigResource) {
                params.loader.add(
                    this.iCmsConfigResource.retrieve({
                        bareUrl: NAttributeOrder.ID
                    }, params)
                );
            }
        }

        params.loader.add(this.vipService.loadForCategory(this));
    }
    /**
     * Category page layout variant
     */
    get lpLayoutVariant(): string {
        return this.id + '';
    }
}

CategoryResource.instance = LocalCategory;
